const styles = theme => {
  // Use overline font if it exists
  const font = theme.typography.overline ? theme.typography.overline : {};

  return {
    root: {
      padding: '7px 16px',
      minHeight: theme.spacing(4),
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.dark,
        backgroundColor: 'inherit'
      }
    },
    disabled: {},
    contained: {
      '&$disabled': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.action.disabled
      }
    },
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText
      }
    },
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText
      }
    },
    outlinedPrimary: {
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        border: `1px solid ${theme.palette.primary.dark}`,
        color: theme.palette.primary.dark
      }
    },
    iconOnly: {
      '&$root': {
        minWidth: 'inherit',
        padding: '8px 11px'
      },
      '& $startIcon': {
        margin: 0,
        marginRight: '-6px'
      },
      '& $endIcon': {
        margin: 0,
        marginLeft: '-3px',
        marginRight: '-3px'
      }
    },
    label: {
      ...font,
      lineHeight: 1,
      padding: '1px 0px'
    },
    startIcon: {
      '& > *:first-child': {
        fontSize: 16
      }
    },
    endIcon: {
      '& > *:first-child': {
        fontSize: 16
      }
    }
  };
};

export const expandStyles = theme => ({
  root: {},
  arrowIcon: {},
  label: {
    ...theme.typography.body2,
    textTransform: 'capitalize',
    lineHeight: 1,
    padding: '1px 0px'
  },
  pointLeft: {
    '& $arrowIcon': {
      transform: 'rotate(90deg)'
    }
  },
  pointRight: {
    '& $arrowIcon': {
      transform: 'rotate(-90deg)'
    }
  },
  pointUp: {
    '& $arrowIcon': {
      transform: 'rotate(180deg)'
    }
  },
  pointDown: {}
});

export const backgroundButtonStyles = theme => {
  // brandColors is not in default MUI so back up to primary dark
  const themeColor = theme.brand
    ? theme.brand.darkBlue
    : theme.palette.primary.dark;
  return {
    root: props => ({
      color: `${props.color || themeColor}`,
      border: `1px solid ${theme.palette.grey[300]}`,
      borderLeft: `2px solid ${props.color || themeColor}`,
      borderRadius: 0,
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
        color: `${props.color || themeColor}`
      }
    }),
    label: {
      ...theme.typography.body2,
      textTransform: 'capitalize',
      lineHeight: 1,
      padding: '1px 0px'
    },
    // need props function to override root
    disabled: props => ({
      borderLeft: `2px solid ${theme.palette.action.disabled}`
    })
  };
};

export const surfaceButtonStyles = theme => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    }
  }
});

export default styles;
